<template>
  <v-container v-if="isMainAdmin" fluid>
    <v-row>
      <v-col>
        <v-toolbar>
          <v-toolbar-title
              :dark="$vuetify.theme.dark"
              flat>
            <v-col class="text-center">
              {{ $t('Проверка принятых сообщений SignalR') }}
            </v-col>
          </v-toolbar-title>
          <v-row>
            <v-col class="text-right">
              <icon-tip
                  icon="swap_vertical_circle"
                  :icon-color="connected
                    ? 'success'
                    : 'error'"
                  :tip="$t(connected
                    ? 'Подключен'
                    : 'Отключен')" />
              <btn-icon-tip
                  :disabled="!connected"
                  icon="question_answer"
                  :tip="$t('Отправить сообщение')"
                  @click="sendMessage" />
            </v-col>
          </v-row>
        </v-toolbar>
        <v-card-title />
        <v-data-iterator
            :items="messages"
            :items-per-page="10"
            sort-by="date"
            sort-desc
            disable-filtering>
          <template v-slot:header>
            <v-toolbar
                class="mb-2 mx-2"
                color="primary"
                :dark="$vuetify.theme.dark"
                flat
                dense
                rounded>
              <v-row
                  :class="'title-container text-subtitle-1' ">
                <v-col class="text-left">
                  {{ $t('Время') }}
                </v-col>
                <v-col class="text-left">
                  {{ $t('Владелец') }}
                </v-col>
                <v-col class="text-left">
                  {{ $t('Адрес') }}
                </v-col>
                <v-col class="text-left">
                  {{ $t('Событие') }}
                </v-col>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item="{ item }">
            <v-card
                :key="item.date"
                outlined
                class="message-diff">
              <v-card-title>
                <v-row
                    class="title-container diff">
                  <v-col>
                    <b>
                      {{ item.date
                        ? $moment(item.date).format('DD.MM.YYYY HH:mm:ss')
                        : null }}
                    </b>
                  </v-col>
                  <v-col class="text-left">
                    {{ item.userName }}
                  </v-col>
                  <v-col class="text-left">
                    <b>
                      {{ item.address }}
                    </b>
                  </v-col>
                  <v-col class="text-left">
                    <b>
                      {{ $t(item.message) }}
                    </b>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

.message-diff {
  border: 2px rgb(76, 154, 233) solid !important;
  margin: 10px !important;
}

.title-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 3px;
}

.diff {
  background-color: rgba(45, 47, 46, 0.2);
  border: 1px rgba(45, 47, 46, 0.2) solid !important;
  border-radius: 4px;
}

</style>

<script>
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import signalRMixin from '@/utils/mixins/scoped/signalRMixin.js'
  import {
    URL_BUSINESS_HUB,
    SIGNALR_MIXIN_PARAMS,
    SIGNALR_EVENT_NAMES,
    SIGNALR_INVOKE_NAMES,
    SIGNALR_CALLBACK_NAMES,
    SIGNALR_TEST_GROUP
  } from '@/constants/signalR'

  export default {
    components: {
      IconTip,
      BtnIconTip
    },
    mixins: [
      signalRMixin({
        [SIGNALR_MIXIN_PARAMS.GET_HUB_METHOD_NAME]: SIGNALR_CALLBACK_NAMES.GET_HUB_NAME,
        [SIGNALR_MIXIN_PARAMS.EVENTS_LIST]: [{
          [SIGNALR_MIXIN_PARAMS.EVENT_NAME]: SIGNALR_EVENT_NAMES.CATCH_NEW_MESSAGE,
          [SIGNALR_MIXIN_PARAMS.CALLBACK_NAME]: SIGNALR_CALLBACK_NAMES.CATCH_NEW_MESSAGE
        }],
        [SIGNALR_MIXIN_PARAMS.INVOKE_LIST]: [{
          [SIGNALR_MIXIN_PARAMS.METHOD_NAME]: SIGNALR_INVOKE_NAMES.ADD_TO_TEST_GROUP
          // [SIGNALR_MIXIN_PARAMS.GET_GROUP_NAME_METHOD]: SIGNALR_CALLBACK_NAMES.GET_SIGNALR_GROUP_NAME
        }]
      })],
    data () {
      return {
        messages: []
      }
    },
    mounted () {
      this.startSignalR()
    },
    methods: {
      [SIGNALR_CALLBACK_NAMES.GET_SIGNALR_GROUP_NAME]: function () {
        return SIGNALR_TEST_GROUP
      },
      [SIGNALR_CALLBACK_NAMES.GET_HUB_NAME]: function () {
        return URL_BUSINESS_HUB
      },
      sendMessage: function () {
        if (this.connected) {
          this.connection.invoke(SIGNALR_INVOKE_NAMES.SEND_TEST_MESSAGE, this.$t('Нажал кнопку'))
        }
      },
      [SIGNALR_CALLBACK_NAMES.CATCH_NEW_MESSAGE]: function (messageInfo) {
        this.messages.push(messageInfo)
      }
    }
  }
</script>
